import { render, staticRenderFns } from "./PrivacyPolicyKO.vue?vue&type=template&id=32a1614e&scoped=true"
import script from "./PrivacyPolicyKO.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyKO.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyKO.vue?vue&type=style&index=0&id=32a1614e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a1614e",
  null
  
)

export default component.exports